// Lane 1364: the deck card's "Which supplier is this deck for?" question.
//
// The server sends `conversation_deck_proposal_outcome` with
// code `template_supplier_needed` when the buyer asked for a deck and no
// supplier could be resolved (a misspelled name, two close names, or no name
// at all). Before this lane that turn showed nothing: no card, no picker, no
// message. This renders the question and reuses the existing chat supplier
// picker (SupplierDisambiguation: the suggested rows plus the search field
// over GET /api/suppliers/search, existing suppliers only).
//
// Picking a supplier sends one ordinary chat message that names it by its
// full directory name. The server then resolves that name against the
// company's own suppliers, exactly as if the buyer had typed it, and the
// normal deck card follows. The browser never supplies a supplier id.
import React from 'react';
import SupplierDisambiguation from '../SupplierDisambiguation';
import './conversationDeckProposal.css';

export const SUPPLIER_ASK_CODE = 'template_supplier_needed';

export function deckSupplierReply(supplierName) {
  return `Build the deck for ${supplierName}.`;
}

export default function ConversationDeckSupplierAsk({
  outcome, resolvedName, disabled, getAuthHeaders, onPick,
}) {
  if (!outcome || outcome.code !== SUPPLIER_ASK_CODE) return null;
  const actionData = {
    scope: 'supplier',
    slots: [{ candidates: Array.isArray(outcome.suppliers) ? outcome.suppliers : [] }],
    original_query: '',
  };
  return (
    <div className="cdp-ask" data-testid="cdp-supplier-ask">
      <p className="cdp-ask-q" role="status">{outcome.message}</p>
      <SupplierDisambiguation
        actionData={actionData}
        resolved={resolvedName}
        state={resolvedName ? 'resolved' : 'pending'}
        disabled={disabled}
        getAuthHeaders={getAuthHeaders}
        onPick={(pick) => {
          if (pick && pick.echoText) onPick(pick.echoText);
        }}
      />
    </div>
  );
}
